export default __webpack_public_path__ + "static/media/tmp_car_image.698210e8.png";